import { createSelectorHook } from 'react-redux';

import type { ReduxState } from 'src/types';

export const useTypedSelector = createSelectorHook<ReduxState>();
